import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DigitalCheckInStoreSettingsComponent } from './digital-check-in-store-settings/digital-check-in-store-settings.component';
import { ShellComponent } from './shell/shell.component';
import { ApiModule } from '@quorum/api';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { MarketingStoreSettingsComponent } from './marketing-store-settings/marketing-store-settings.component';
import { ProfileComponent } from './profile/profile.component';
import { ShaComponentsNgUiModule } from '@quorum/sha-components-ng-ui';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ProfileSettingsComponent } from './profile-settings/profile-settings.component';
import { MarketingComponent } from './marketing/marketing.component';
import { DigitalCheckInComponent } from './digital-check-in/digital-check-in.component';
import { ProfilePictureComponent } from './profile-picture/profile-picture.component';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  imports: [
    ImageCropperModule,
    CommonModule,
    ApiModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    CommonMaterialComponentsModule,
    MatSidenavModule,
    ShaComponentsNgUiModule,
  ],
  declarations: [
    DigitalCheckInStoreSettingsComponent,
    ShellComponent,
    MarketingStoreSettingsComponent,
    ProfileComponent,
    ProfileSettingsComponent,
    MarketingComponent,
    DigitalCheckInComponent,
    ProfilePictureComponent,
  ],
  exports: [
    DigitalCheckInStoreSettingsComponent,
    ShellComponent,
    MarketingStoreSettingsComponent,
    ProfileComponent,
    ProfileSettingsComponent,
    MarketingComponent,
    DigitalCheckInComponent,
  ],
})
export class SettingsNgUiModule {}
